<template>
  <ul class="prices" :class="{ 'is-loading': isLoading }">
    <slot />
  </ul>
</template>
<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.prices {
  padding: 0;
  margin: 0;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 17.5em;
  background-color: white;
  border-radius: 15px;
}
.is-loading.prices {
  background: #d9d9d9;
  min-height: 30em;
}
.scroll-snap.scroll-snap-active {
  .prices {
    scroll-snap-align: center;
  }
}
</style>
